import React, { useState } from 'react'
import { connect } from 'react-redux'
import {  Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { endOfDay } from "date-fns"

import { defaultTableOptions, paginationOptions } from '../../helpers/table'

import { getFleetAdminEventsLog } from '../../../action/FleetAdminActions'
import { getUserLogs, getCompanyLogs } from '../../../action/ClientActions'
import { formatTimestamp } from '../../helpers/tablesFuncHelpers'
import CustomButton from '../../CustomButton'
import CalendarDropdown from '../CalendarDropdown'
import SearchBar from '../../SearchBar'
import DateDropdown from '../../dump/menuComponents/DateDropdown'

const ModalDeviceAuditLog = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'modals.modalDeviceAuditLog' });
	const { type, device, user_role, loaderModal } = props;

	const [logs, setLogs] = useState([]);
	const [logs_sample, setLogs_sample] = useState([]);
	const [elastic_sample, setElastic_sample] = useState(0);
	const [elastic_total, setElastic_total] = useState(0);
	const [metadata_total, setMetadata_total] = useState(0);
	const [start_date, setStart_date] = useState(moment().subtract(4, 'days').format("YYYYMMDD"));
	const [end_date, setEnd_date] = useState(moment().format("YYYYMMDD"));
	const [page, setPage] = useState(1);
	const [sizePerPage, setSizePerPage] = useState(10);
	const [totalSize, setTotalSize] = useState(0);
	const [reportSearch, setReportSearch] = useState('');

	const onEnterModal = () => {
		setLogs([]);
		setLogs_sample([]);
		setElastic_sample(0);
		setElastic_total(0);
		setMetadata_total(0);
		setStart_date(moment().subtract(4, 'days').format("YYYYMMDD"));
		setEnd_date(moment().format("YYYYMMDD"));

		setPage(1);
		setSizePerPage(10);
		setTotalSize(0);

		changedEventsList();
	}

	const changedEventsList = () => {
		if (type && (type == 'user_logs' || type == 'company_logs')) {
			return getUserLogsFnc()
		}

		return getEventsLogs()
	}

	const getUserLogsFnc = () => {
		props.toggleLoaderModal(true)

		const params = {
			start_date: start_date,
			end_date: end_date,
			user_role: user_role,
			filter_type: reportSearch,
		}

		let request = null
		if (type && type == 'user_logs') {
			request = getUserLogs;
			params.user_id = device.id
		}
		else if (type && type == 'company_logs') {
			request = getCompanyLogs;
			params.company_id = device.id
		}

		request(params)
			.then((res, err) => {
				props.toggleLoaderModal(false)
				console.log('!getUserLogs res', res)

				const response = res.data.response

				setLogs_sample(response.logs);
			})
			.catch((error) => {
				props.toggleLoaderModal(false)
				console.log(error)

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}

	const getEventsLogs = () => {
		props.toggleLoaderModal(true)

		const params = {
			start_date: start_date,
			end_date: end_date,
			device_id: (device) ? device.device_id : '',
			page_number: elastic_sample,
			user_role: user_role,
			filter_type: reportSearch || '',
		}

		getFleetAdminEventsLog(params)
			.then((res, err) => {
				console.log('!getEventsLogs res', res)

				props.toggleLoaderModal(false)

				const response = res.data.response;
				const ulogs = _.union(logs, response.logs)

				setLogs(ulogs);
				setLogs_sample(ulogs.slice((page - 1) * sizePerPage, sizePerPage * page));
				setElastic_sample(elastic_sample + response.elastic_sample);
				setElastic_total(response.elastic_total);
				setMetadata_total(response.metadata_total);
				setTotalSize(response.elastic_total + response.metadata_total);
			})
			.catch((error) => {
				props.toggleLoaderModal(false)
				console.log(error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}

	const reloadList = () => {
		if (start_date && end_date && (moment(end_date).diff(start_date) > 0)) {
			setLogs([]);
			setLogs_sample([]);
			setElastic_sample(0);
			setElastic_total(0);
			setMetadata_total(0);

			setPage(1);
			setTotalSize(0);

			changedEventsList();
		}
		else {
			toastr.error(i18n.t('toastMessage.errEndDateBiggerStartDate'))
		}
	}

	const onDateChanged1 = (current) => {
		setStart_date(moment(current).format('YYYYMMDD'));
	}

	const onDateChanged2 = (current) => {
		setEnd_date(moment(current).format('YYYYMMDD'));
	}

	const handlePageChange = (page, sizePerPage) => {
		const logs_sample = logs.slice(sizePerPage * (page - 1), sizePerPage * page),
			logs_len = logs.length

		if (logs_sample.length < sizePerPage && logs_len < totalSize) {
			setPage(page);
			changedEventsList();
		}
		else {
			setPage(page);
			setLogs_sample(logs_sample);
		}
	}

	const getTitle = () => {
		let title = ''

		if (type && type == 'user_logs') {
			title = device ? device.first_name + ' ' + device.last_name : ''
		}
		else if (type && type == 'company_logs') {
			title = device ? device.company_name : ''
		}
		else {
			title = device ? device.device_name || device.device_id : ''
		}

		return title
	}

	const options = {
		...paginationOptions,
		withFirstAndLast: elastic_sample >= elastic_total, // Hide the going to First and Last page button
	}

	let opts = {}
	if (type && (type == 'user_logs' || type == 'company_logs')) {
	} else {
		options.onPageChange = handlePageChange
		opts['remote'] = true
		opts['fetchInfo'] = { dataTotalSize: totalSize }
	}

	const eventtypeFormatter = (cell, row) => {
		return cell.replace(/Fatal/, t('textCritical'))
	}

	const changeDate = (selected_start_date, selected_end_date) => {
        const new_start_date = selected_start_date ? moment(selected_start_date).format('YYYYMMDD') : start_date;
        const new_end_date = selected_end_date ? moment(selected_end_date).format('YYYYMMDD') : end_date;
        setStart_date(new_start_date);
        setEnd_date(new_end_date);
    }

	return (
		<Modal
			size='xl'
			show
			onHide={props.onHide}
			onEnter={onEnterModal}
			aria-labelledby="contained-modal-title-lg"
			dialogClassName="modal-audit-lg"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">{t('titleAuditLog')} - {getTitle()}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{/* <div className="modal-audit-log audit-view-modal">
					<div className="row reload-dates-mobile" style={{ display: 'flex' }}>
						<div className="col-md-4 date-container">
							<div className="date"><span>{t('titleStartDate')}</span></div>
							<div className="datetime">
								<CalendarDropdown
									date={moment(start_date)}
									onChange={onDateChanged1}
								/>
							</div>
						</div>
						<div className="col-md-4 date-container">
							<div className="date"><span>{t('titleEndDate')}</span></div>
							<div className="datetime">
								<CalendarDropdown
									date={moment(end_date)}
									onChange={onDateChanged2}
								/>
							</div>
						</div>
						<div className="col-md-4" style={{ paddingTop: '5px', paddingBottom: '5px' }}>
							<CustomButton
								onClick={reloadList}
								variant="primary-outline"
							>
								{t('btnReload')}
							</CustomButton>
						</div>
					</div>
				</div> */}

				<div className="subheader">
					<div className="subheader-section-left">
						<div style={{flexBasis: '100%'}}>
							<SearchBar term={reportSearch} onSearch={(e) => setReportSearch(e.target.value)} />
						</div>

						<DateDropdown
							start_date={start_date}
							end_date={end_date}
							onSelectDate={changeDate}
							singleDate={true}
							maxDate={endOfDay(new Date())}
						/>
					</div>

					<div className="subheader-section-right">
						<CustomButton
							onClick={reloadList}
							variant="primary-outline"
						>
							{t('btnReload')}
						</CustomButton>
					</div>
				</div>

				<div className="manage-users-table audit-view-page-table" style={{ clear: 'both', marginTop: '20px' }}>
					<BootstrapTable
						data={logs_sample}
						{...defaultTableOptions}
					>
						<TableHeaderColumn
							isKey
							width="20%"
							dataField="timestamp"
							dataFormat={(cell) => formatTimestamp(cell)}
						>
							{t('titleTimestamp')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="25%"
							dataField="type"
							dataFormat={eventtypeFormatter}
						>
							{t('titleType')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="55%"
							dataField="desc"
							tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
						>
							{t('titleDescription')}
						</TableHeaderColumn>
					</BootstrapTable>
				</div>
			</Modal.Body>
			{loaderModal}
		</Modal>
	)
}

export default connect(
	state => ({
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(ModalDeviceAuditLog);
